import React from 'react';
import Tile from './Tile';
import { TileGridProps } from './Types';

const TileGrid = ({ tiles, backgroundColor, tileFontStyle }: TileGridProps) => {
  return (
    <div className="columns-1 md:columns-2 gap-4 sm:gap-6 mt-4 p-4" data-testid="tile-grid">
      {tiles.map((text) => (
        <div key={text} className="mb-6 sm:mb-8 break-inside-avoid">
          <Tile
            text={text}
            backgroundColor={backgroundColor || ''}
            tileFontStyle={tileFontStyle}
          />
        </div>
      ))}
    </div>
  );
};

export default TileGrid;
